import { FC, useMemo } from 'react';
import { Popup, TPopupComponent } from '../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../shared/components/popup/services/popup.service';
import { useTranslation } from 'react-i18next';
import { Content } from './content.popup';
import { styled } from '@mui/material';

export class VersionsPopup extends Popup<IVersionsPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 448 },
        }));
      }, []);
      return (
        <SWrapper stream={stream} popupTitle={t('production.manage_versions')} fullWidth>
          <Content stream={stream} />
        </SWrapper>
      );
    };
  }
}

export interface IVersionsPopup {
  action: TPopupDefaultActions;
  date: string;
}
